module.exports = __webpack_public_path__ + "9c6775b9ef21a13fb4116931cdb692ad.png";


//////////////////
// WEBPACK FOOTER
// ./assets/thumbnails/book-trading.png
// module id = ./assets/thumbnails/book-trading.png
// module chunks = 2